export const KB = 1024
export const MB = 1024 * KB

export const MAX_FILE_SIZE = 4 * MB
export const ALLOWED_FILES_SIZE = 10 * MB
export const ALLOWED_FILES_EXTENSIONS = ['.pdf', '.png', '.jpg', 'jpeg']
export const ALLOWED_FILES_COUNT = 1

export const ERROR_TYPES = {
  MAX_FILE_SIZE_EXCEEDED: 'MAX_FILE_SIZE_EXCEEDED',
  WRONG_FILE_EXTENSION: 'WRONG_FILE_EXTENSION',
}
